import { render, staticRenderFns } from "./noBodyLearningVideoList.vue?vue&type=template&id=2a35b0b1&scoped=true"
import script from "./noBodyLearningVideoList.vue?vue&type=script&lang=js"
export * from "./noBodyLearningVideoList.vue?vue&type=script&lang=js"
import style0 from "./noBodyLearningVideoList.vue?vue&type=style&index=0&id=2a35b0b1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35b0b1",
  null
  
)

export default component.exports